import React from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';

const GlobalValidationLabel = ({ validationError }) =>
    (
        <TransitionGroup>
            {validationError &&
                <CSSTransition
                    key="globalValidation"
                    classNames="list-item"
                    timeout={300}
                >
                    <Row className="justify-content-center">
                        <Col xs="auto" className="text-danger animation-wrapper">
                            {validationError}
                        </Col>
                    </Row>
                </CSSTransition>
            }
        </TransitionGroup>
    );

GlobalValidationLabel.propTypes = {
    validationError: PropTypes.string
};

export default GlobalValidationLabel